document.addEventListener('DOMContentLoaded', () => {
  const ac = new Accordion('.seo-footer-links--outer-wrapper', {
    openOnInit: window.innerWidth < 768 ? [] : [0],
  });

  let currentState = window.innerWidth > 768 ? 'open' : 'closed';

  // Create a resize observer that opens all accordions when the window is resized to a width greater than 768px
  const resizeObserver = new ResizeObserver((entries) => {
    for (let entry of entries) {
      if (entry.contentRect.width > 768 && currentState === 'closed') {
        ac.openAll();
        currentState = 'open';
      } else if (entry.contentRect.width < 768 && currentState === 'open') {
        ac.closeAll();
        currentState = 'closed';
      }
    }
  });

  resizeObserver.observe(document.body);
});
